/**
 * Shared types for StatusControl components
 * Used by both CandidateStatusControl and JobStatusControl
 */

export interface StatusConfig {
  label: string;
  color: string;
  bgColor: string;
}

export interface ArchiveReasonConfig {
  label: string;
  description: string;
}

export interface StatusTransition {
  value: string;
  label: string;
}

export interface EntityStatusControlConfig {
  statusConfig: Record<string, StatusConfig>;
  archiveReasons: Record<string, ArchiveReasonConfig>;
  entityName: string;
  entityNamePlural: string;
  defaultStatus: string;
  queryKeys: {
    entity: string;
    entities: string;
    transitions: string;
  };
}

export interface ArchiveModalProps {
  isOpen: boolean;
  onClose: () => void;
  onArchive: (data: ArchiveData) => void;
  isLoading: boolean;
  entityName: string;
  archiveReasons: Record<string, ArchiveReasonConfig>;
  showDuplicateField?: boolean;
  showGdprWarning?: boolean;
  customReasonInfoBox?: {
    reason: string;
    message: string;
    bgColor: string;
    textColor: string;
  };
}

export interface ArchiveData {
  archive_reason: string;
  archive_reason_note: string | null;
  duplicate_of_id?: number | null;
  note?: string;
}

export interface StatusBadgeProps {
  status: string;
  statusConfig: Record<string, StatusConfig>;
  defaultStatus: string;
  size?: 'small' | 'medium' | 'large';
  onClick?: (event: React.MouseEvent) => void;
  clickable?: boolean;
}

export interface StatusDropdownItem {
  value: string;
  label: string;
  color: string;
  bgColor: string;
  isAllowed: boolean;
  isCurrent: boolean;
  disabledReason: string | null;
}

export const SIZE_STYLES = {
  small: { padding: '2px 8px', fontSize: '11px' },
  medium: { padding: '4px 12px', fontSize: '12px' },
  large: { padding: '6px 16px', fontSize: '14px' }
} as const;
